import { render } from "./PartnerApiIntegrationGuide.vue?vue&type=template&id=196e6f7a&scoped=true"
import script from "./PartnerApiIntegrationGuide.vue?vue&type=script&lang=js"
export * from "./PartnerApiIntegrationGuide.vue?vue&type=script&lang=js"

import "./PartnerApiIntegrationGuide.vue?vue&type=style&index=0&id=196e6f7a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196e6f7a"]])

export default __exports__